import React from "react";
import {useTranslation} from "react-i18next";
import {
  dateToLocalizedFormat,
  daysBetweenDates,
  stringToDate
} from "common/src/utils/DateUtils";
import PropTypes from "prop-types"
import {offerStatus} from "../../model/offerStatus";
import {toEuroCurrency} from "common/src/utils/CurrencyUtils";

function OfferDetailsCard(props) {
  const {t} = useTranslation();
  const offerStatusList = offerStatus();
  const startDate = stringToDate(props.requestDetails?.startDate);
  const endDate = stringToDate(props.requestDetails?.endDate);
  const numberOfDays = daysBetweenDates(endDate, startDate) + 1;

  return (
    <div className="card is-full-height">
      <header className="card-header has-height-75">
        <p className="card-header-title">
          <span className="icon fz fz-cog medium mr-1"/>
          <span>{t("offer.offer_details")}</span>
        </p>
        <div className="is-right card-header-icon">
          <div className={"dropdown is-right is-hoverable"}>
            <div className="dropdown-trigger">
              <button className="button is-primary"
                      type="button"
                      aria-haspopup="true"
                      aria-controls="dropdown-menu4">
                       <span className="fz fz-ellipsis"
                             aria-hidden="true"></span>
              </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu4"
                 role="menu">
              <div className="dropdown-content">
                { ['SENT', 'BOOKING_PENDING', 'BOOKED'].includes(props.offerDetails?.status) &&
                  <a className="dropdown-item"
                     onClick={props.reject}>
                    {t("offer.reject_offer")}
                  </a>
                }
                { props.offerDetails?.status === 'OPEN' &&
                  <a className="dropdown-item"
                     onClick={props.send}>
                    {t("offer.send_off")}
                  </a>
                }
                { ['OPEN', 'SENT', 'BOOKING_PENDING'].includes(props.offerDetails?.status) &&
                  <a className="dropdown-item"
                     onClick={props.bookWithProvider}>
                    {t("offer.book_with_the_provider")}
                  </a>
                }
                { props.offerDetails?.status === 'BOOKING_PENDING' &&
                  <a className="dropdown-item"
                     onClick={props.confirmed}>
                    {t("offer.booking_confirmed")}
                  </a>
                }
                <a className="dropdown-item"
                   onClick={props.downloadDocumentEng}>
                  {t("offer.download_travel_document_en")}
                </a>
                <a className="dropdown-item"
                   onClick={props.downloadDocumentDe}>
                  {t("offer.download_travel_document_de")}
                </a>
                <a className="dropdown-item"
                   onClick={props.downloadOfferDocumentDe}>
                  {t("offer.download_offer_document_de")}
                </a>
                <a className="dropdown-item"
                   onClick={props.downloadOfferDocumentEng}>
                  {t("offer.download_offer_document_en")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="card-content">
        <OfferDetailsRow
          name={t("offer.created")}
          value={props.offerDetails && dateToLocalizedFormat(props.offerDetails.dateCreated)} />
        <OfferDetailsRow
          name={t("offer.days_in_request")}
          value={numberOfDays || 0} />
        <OfferDetailsRow
          name={t("offer.days_in_offer")}
          value={props.daysInOffer} />
        <OfferDetailsRow
          name={t("offer.price")}
          value={toEuroCurrency(props.offerPrice)}
        />
        <OfferDetailsRow
          name={t("offer.status.status")}
          value={props.offerDetails && offerStatusList.find(c => c.id === props.offerDetails.status).name}
        />
      </div>
    </div>
  );
}

OfferDetailsCard.propTypes = {
  name: PropTypes.object,
  formField: PropTypes.object
};

function OfferDetailsRow(props) {
  return (
    <div className="columns is-mobile">
      <div className="column is-6 mr-2">{props.name + ":"}</div>
      <div className="column is-6">{props.value}</div>
    </div>
  )
}

OfferDetailsRow.propTypes = {
  name: PropTypes.any,
  value: PropTypes.any
}

export default OfferDetailsCard;
